import type { MultiSelectDef } from '../types';

interface MultiSelectFieldProps {
  question: MultiSelectDef;
  value: string[];
  onChange: (selectedIds: string[]) => void;
}

/**
 * MultiSelectField
 * チェックボックス風の複数選択フィールド
 * 四角いインジケーター、チェックマーク
 */
export function MultiSelectField({ question, value, onChange }: MultiSelectFieldProps) {
  const toggle = (id: string) => {
    const newValue = value.includes(id)
      ? value.filter((v) => v !== id)
      : [...value, id];
    onChange(newValue);
  };

  return (
    <div className="space-y-2.5">
      {question.options.map((option) => (
        <button
          key={option.id}
          type="button"
          aria-pressed={value.includes(option.id)}
          onClick={() => toggle(option.id)}
          className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg border-2 transition-all cursor-pointer text-left ${
            value.includes(option.id)
              ? 'border-[#0052FF] bg-[#F0F5FF]'
              : 'border-[#E5E7EB] bg-white hover:border-[#0052FF]/30'
          }`}
        >
          <div
            className={`flex-shrink-0 w-5 h-5 rounded border-2 flex items-center justify-center ${
              value.includes(option.id)
                ? 'border-[#0052FF] bg-[#0052FF]'
                : 'border-[#D1D5DB]'
            }`}
          >
            {value.includes(option.id) && (
              <svg
                className="w-3.5 h-3.5 text-white"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={3}
                  d="M5 13l4 4L19 7"
                />
              </svg>
            )}
          </div>
          <span className="text-[#111827] text-sm font-medium">
            {option.label}
          </span>
        </button>
      ))}
    </div>
  );
}
